<template>
    <div
        class="c-toppage-top"
        v-show="screenWidth"
        :class="
            screenWidth > 1919
                ? 'top_bg_3840 space-center'
                : screenWidth > 1440
                ? 'top_bg_1920 space-between'
                : 1024 < screenWidth && screenWidth < 1440
                ? 'top_bg_1440 space-between'
                : 'top_bg_1024 space-between'
        "
    >
        <!-- <div class="logo">
            <img :src="logoSrc" alt="" style="width: 96px; height: 41px" />
        </div> -->
        <div class="logo-box" :style="1919 < screenWidth ? 'flex: 1' : ''">
            <div class="logo-left" :class="screenWidth < 1920 ? 'logo-left-no' : ''"></div>
            <!-- <div class="logo" style="width: 102px; height: 41px"></div> -->
            <img class="logo" :src="logoSrc" style="width: 102px; height: 41px" alt="" />
        </div>
        <!-- 1920*1080 -->
        <template v-if="screenWidth > 1919">
            <div
                :class="type === 'main' ? 'title-left-off' : 'title-left'"
                class="c-toppage-top__nav"
                @click="btnType('main')"
            >
                指挥调度
            </div>
            <div
                class="c-toppage-top__nav"
                :class="type === 'task' ? 'title-left-off' : 'title-left'"
                @click.stop="btnType('task')"
            >
                飞行任务
            </div>
            <div
                class="c-toppage-top__nav"
                :class="type === 'route' ? 'title-left-off' : 'title-left'"
                @click.stop="btnType('route')"
            >
                航线规划
            </div>
        </template>
        <!-- 1440*800 -->
        <template v-else-if="1440 < screenWidth && screenWidth < 1920">
            <div
                :class="type === 'main' ? 'title-left-off' : 'title-left'"
                class="c-toppage-top__nav"
                @click="btnType('main')"
            >
                指挥调度
            </div>

            <el-popover
                popper-class="title-popover mark-bg_96"
                placement="bottom"
                width="165"
                trigger="click"
                ref="leftInPopover"
            >
                <div class="popover-items">
                    <div
                        v-for="item in titleLeftList"
                        :key="item.type"
                        class="popover-item"
                        :class="{ 'is-active': type === item.type }"
                        @click="btnType(item.type, 2)"
                    >
                        {{ item.name }}
                    </div>
                </div>
                <div
                    class="c-toppage-top__nav"
                    :class="type === 'task' || type === 'route' ? 'title-left-in-off' : 'title-left-in'"
                    @click.stop="btnShowType('left-in')"
                    slot="reference"
                ></div>
            </el-popover>
        </template>
        <!-- 1024*768 -->
        <template v-else>
            <el-popover
                popper-class="title-popover mark-bg_144"
                placement="bottom"
                width="165"
                trigger="click"
                ref="leftMinPopover"
            >
                <div class="popover-items">
                    <div
                        v-for="item in titleLeftList"
                        :key="item.type"
                        class="popover-item"
                        :class="{ 'is-active': type === item.type }"
                        @click="btnType(item.type, 2)"
                    >
                        {{ item.name }}
                    </div>
                </div>
                <div
                    class="c-toppage-top__nav"
                    :class="
                        type === 'main' || type === 'task' || type === 'route'
                            ? 'title-left-min-off'
                            : 'title-left-min'
                    "
                    @click.stop="btnShowType('left-min')"
                    slot="reference"
                ></div>
            </el-popover>
        </template>
        <div class="c-toppage-top__title" :style="'font-size:' + (title.length > 12 ? '26' : '32') + 'px;'">
            {{ title }}
            <Light
                :activeLightMap="activeLightMap"
                class="c-toppage-top__light1"
                :style="'left:' + (title.length > 12 ? '65' : '91') + 'px;'"
            />
            <Light
                :activeLightMap="activeLightMap"
                class="c-toppage-top__light2"
                :style="'left:' + (title.length > 12 ? '65' : '91') + 'px;'"
            />
            <div class="c-toppage-top__title-light"></div>
            <Light
                :activeLightMap="activeLightMap"
                class="c-toppage-top__light3"
                :style="'right:' + (title.length > 12 ? '65' : '91') + 'px;'"
                :reverse="true"
            />
            <Light
                :activeLightMap="activeLightMap"
                class="c-toppage-top__light4"
                :style="'right:' + (title.length > 12 ? '65' : '91') + 'px;'"
                :reverse="true"
            />
        </div>
        <!-- 1920*1024 -->
        <template v-if="screenWidth > 1919">
            <div
                class="c-toppage-top__nav"
                :class="type === 'device' ? 'title-right-off' : 'title-right'"
                @click.stop="btnType('device')"
            >
                数据管理
            </div>
            <div
                class="c-toppage-top__nav"
                :class="type === 'hydroelectricity' ? 'title-right-off' : 'title-right'"
                @click.stop="btnType('hydroelectricity')"
            >
                水力电分析
            </div>
            <div
                class="c-toppage-top__nav"
                :class="type === 'backstage' ? 'title-right-off' : 'title-right'"
                @click.stop="btnType('backstage')"
            >
                后台管理
            </div>
            <!-- <div
                class="c-toppage-top__nav"
                :class="type === 'sitemanage' ? 'title-right-off' : 'title-right'"
                @click.stop="btnType('sitemanage')"
            >
                站点管理
            </div> -->
        </template>
        <!-- 1440*800 -->
        <template v-else-if="1440 < screenWidth && screenWidth < 1920">
            <div
                class="c-toppage-top__nav"
                :class="type === 'device' ? 'title-right-off' : 'title-right'"
                @click.stop="btnType('device')"
            >
                数据管理
            </div>
            <el-popover
                popper-class="title-popover mark-bg_96"
                placement="bottom"
                width="165"
                trigger="click"
                ref="rightInPopover"
            >
                <div class="popover-items">
                    <div
                        v-for="item in titleRightList"
                        :key="item.type"
                        class="popover-item"
                        :class="{ 'is-active': type === item.type }"
                        @click="btnType(item.type, 2)"
                    >
                        {{ item.name }}
                    </div>
                </div>
                <div
                    class="c-toppage-top__nav"
                    :class="
                        type === 'device' || type === 'hydroelectricity'
                            ? 'title-right-in-off'
                            : 'title-right-in'
                    "
                    @click.stop="btnShowType('right-in')"
                    slot="reference"
                ></div>
            </el-popover>
        </template>
        <!-- 1024*768 -->
        <template v-else>
            <el-popover
                popper-class="title-popover mark-bg_144"
                placement="bottom"
                width="165"
                trigger="click"
                ref="rightMinPopover"
            >
                <div class="popover-items">
                    <div
                        v-for="item in titleRightList"
                        :key="item.type"
                        class="popover-item"
                        :class="{ 'is-active': type === item.type }"
                        @click="btnType(item.type, 2)"
                    >
                        {{ item.name }}
                    </div>
                </div>
                <div
                    class="c-toppage-top__nav"
                    :class="
                        type === 'device' || type === 'hydroelectricity' || type === 'backstage'
                            ? 'title-right-min-off'
                            : 'title-right-min'
                    "
                    @click.stop="btnShowType('right-min')"
                    slot="reference"
                ></div>
            </el-popover>
        </template>
        <!-- @click="toHome" -->
        <!-- <div class="offbtn" >

        </div> -->
        <div class="offbtn-box" :style="1919 < screenWidth ? 'flex: 1' : ''">
            <el-popover
                popper-class=" title-popover mark-bg_96"
                placement="bottom"
                width="100"
                trigger="click"
                ref="jumpPopover"
                @show="JumpStutas = true"
                @hide="JumpStutas = false"
            >
                <div class="popover-items">
                    <div
                        v-for="item in jumpList"
                        :key="item.type"
                        class="popover-item"
                        :class="{ 'is-active': type === item.type }"
                        @click="btnType(item.type, 2)"
                    >
                        {{ item.name }}
                    </div>
                </div>
                <!-- :class="type === 'device' || type === 'hydroelectricity' ? 'title-right-in-off' : 'title-right-in'" -->
                <div class="c-toppage-top__nav offbtn" slot="reference">
                    <div class="user-circular">
                        <img class="icon-user" :src="userURL ? userURL : defaultAvatar" alt="" />
                    </div>

                    <i :class="JumpStutas ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </div>
            </el-popover>
            <div class="offbtn-box-right"></div>
        </div>
    </div>
</template>

<script>
import Light from './Light.vue';
import api from './api';

export default {
    components: {
        Light,
    },
    props: {
        screenWidth: Number,
        doGetCurrent: Function,
    },
    data() {
        const self = this;
        this.$watch('$route.path', this.refreshPath);
        this.$nextTick().then(() => {
            self.refreshPath(self.$route.path);
        });
        setInterval(() => {
            this.activeLightMap[1] += 1;
            this.activeLightMap[2] += 1;
            this.activeLightMap[3] += 1;
            this.activeLightMap[4] += 1;
            this.activeLightMap[5] += 1;
            if (this.activeLightMap[1] === 5) this.activeLightMap[1] = 1;
            if (this.activeLightMap[2] === 5) this.activeLightMap[2] = 1;
            if (this.activeLightMap[3] === 5) this.activeLightMap[3] = 1;
            if (this.activeLightMap[4] === 5) this.activeLightMap[4] = 1;
            if (this.activeLightMap[5] === 5) this.activeLightMap[5] = 1;
        }, 500);
        return {
            defaultAvatar: require('./imgs/icon-user.png'),
            logoSrc: window.gconfig.logoSrc,
            JumpStutas: false,
            userURL: '',
            httpURL: '',
            type: null,
            title: window.gconfig.title,
            activeLightMap: {
                1: 1,
                2: 2,
                3: 3,
                4: 4,
                5: 5,
            },
            screenHeight: null,
            titleLeftList: [],
            titleRightList: [],
            titleIn: [
                {
                    name: '飞行任务',
                    type: 'task',
                },
                {
                    name: '航线规划',
                    type: 'route',
                },
                {
                    name: '水力电分析',
                    type: 'hydroelectricity',
                },
                // {
                //     name: '站点管理',
                //     type: 'sitemanage',
                // },
                {
                    name: '后台管理',
                    type: 'backstage',
                },
            ],
            titleMin: [
                {
                    name: '指挥调度',
                    type: 'main',
                },
                {
                    name: '飞行任务',
                    type: 'task',
                },
                {
                    name: '航线规划',
                    type: 'route',
                },
                {
                    name: '数据管理',
                    type: 'device',
                },
                {
                    name: '水力电分析',
                    type: 'hydroelectricity',
                },
                {
                    name: '后台管理',
                    type: 'backstage',
                },
                // {
                //     name: '站点管理',
                //     type: 'sitemanage',
                // },
            ],
            jumpList: [
                // {
                //     name: '后台管理',
                //     type: 'backstage',
                // },
                {
                    name: '返回门户',
                    type: 'gateway',
                },
                {
                    name: '退出登录',
                    type: 'out',
                },
                // {
                //     name: '驭光平台',
                //     type: 'yuguang',
                // },
            ],
            // titleLightStyle: {
            //     tran:
            // },
        };
    },
    watch: {
        screenWidth: {
            handler(val, oldVal) {
                // console.log('屏幕宽度2222', val);
                // switch (val) {
                //     case val > 1024 && val < 1441:
                //         this.titleList = this.titleIn;
                //         break;
                //     case val < 1024:
                //         this.titleList = this.titleMin;
                //         break;
                //     default:
                // }
            },
            immediate: true,
        },
    },
    mounted() {
        this.uploadPrefixPath();
        this.getCurrent();
    },

    methods: {
        getCurrent() {
            this.$props
                .doGetCurrent()
                .then((data) => {
                    let avatar = data.data.data.user.photo;
                    if (avatar) {
                        this.userURL = `${this.httpURL}${avatar} `;
                    } else {
                        this.userURL = this.defaultAvatar;
                    }
                })
                .catch((e) => {});
        },
        uploadPrefixPath() {
            api.uploadPrefixPath()
                .then((data) => {
                    this.httpURL = data.data.data;
                })
                .catch((e) => {});
            // return src;
        },
        refreshPath(path) {
            if (path.indexOf('main') !== -1 || path.indexOf('console')) {
                this.type = 'main';
            }
            if (path.indexOf('task') !== -1) {
                this.type = 'task';
            }
            if (path.indexOf('route') !== -1) {
                this.type = 'route';
            }
            if (path.indexOf('hydroelectricity') !== -1) {
                this.type = 'hydroelectricity';
            }
            if (path.indexOf('device') !== -1) {
                this.type = 'device';
            }
            // this.buildSub = false;
        },
        btnType(type) {
            // if (type === 'device') {
            //     this.$router.push({ path: 'device' });
            // }
            if (
                type === 'main' ||
                type === 'task' ||
                type === 'route' ||
                type === 'hydroelectricity' ||
                type === 'environmental' ||
                type === 'device'
            ) {
                // console.log('this.type', this.type, type);
                if (this.type !== type) {
                    this.$router.push({
                        path: type,
                        query: {
                            t: Date.now(),
                        },
                    });
                }
                this.type = type;
            } else if (type === 'backstage') {
                window.location.href = window.gconfig.home.manage;
            } else if (type === 'gateway') {
                // console.log('window.gconfig', window.gconfig);
                window.location.href = window.gconfig.home.serve;
                this.JumpStutas = !this.JumpStutas;
            } else if (type === 'out') {
                // this.$message({
                //     message: '退出登录正在开发中！！！！',
                //     type: 'warning',
                // });
                api.logout()
                    .run()
                    .then((data) => {
                        window.location.href = data;
                    });
                this.JumpStutas = !this.JumpStutas;
                // window.location.href = window.gconfig.home.out;
            } else if (type === 'yuguang') {
                api.beforeToyuguang({
                    userName: 'xlyg',
                }).then((rep) => {
                    console.log(rep.data);
                    window.open('http://solar.skysys.cn:8080/');
                });
            } else {
                this.$message({
                    message: '模块正在开发中！！！！',
                    type: 'warning',
                });
            }
            // else if (type === 'device') {
            //     this.$router.push({ path: 'device' });
            // }
            this.doClose();
        },
        btnShowType(type) {
            this.doClose();
            switch (type) {
                case 'left-in':
                    this.titleLeftList = this.titleIn.slice(0, 2);
                    break;
                case 'left-min':
                    this.titleLeftList = this.titleMin.slice(0, 3);
                    break;
                case 'right-in':
                    this.titleRightList = this.titleIn.slice(2, 4);
                    break;
                case 'right-min':
                    this.titleRightList = this.titleMin.slice(3, 6);
                    break;
                default:
            }
        },
        toHome() {
            window.location.href = window.gconfig.home.serve;
        },
        doClose() {
            this.$refs.leftInPopover && this.$refs.leftInPopover.doClose();
            this.$refs.leftMinPopover && this.$refs.leftMinPopover.doClose();
            this.$refs.rightInPopover && this.$refs.rightInPopover.doClose();
            this.$refs.rightMinPopover && this.$refs.rightMinPopover.doClose();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

@keyframes titleLight {
    0% {
        transform: translateX(-150px);
    }
    100% {
        transform: translateX(150px);
    }
}
.space-between {
    justify-content: space-between;
}
.space-center {
    justify-content: center;
}
.top_bg_3840 {
    // width: 3840px;
    background: url(./imgs/title_bg_3840.png) center center no-repeat;
}
.top_bg_1920 {
    // width: 1920px;
    background: url(./imgs/title_bg_1920.png) center center no-repeat;
}
.top_bg_1440 {
    // width: 1440px;
    background: url(./imgs/title_bg_1440.png) center center no-repeat;
}
.top_bg_1024 {
    // width: 1024px;
    background: url(./imgs/title_bg_1024.png) center center no-repeat;
}
.mark-bg_144 {
    // 165px 145px
    // height: 144px;
    background: rgba(7, 17, 80, 0.75) url(./imgs/mark-bg-144.png) no-repeat;
    background-size: 100% 100%;
}
.mark-bg_96 {
    // height: 96px;
    background: rgba(7, 17, 80, 0.75) url(./imgs/mark-bg-98.png) no-repeat;
    background-size: 100% 100%;
}
@include b(toppage-top, c) {
    display: flex;
    align-items: center;
    .logo-box {
        // flex: 1;
        min-width: 41px;
        display: flex;
        .logo-left {
            position: relative;
            flex: 1;
            margin-top: 6px;
            &::after {
                content: '';
                display: block;
                width: calc(100% - 10px);
                height: calc(100% - 10px);
                z-index: -2;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: #142b7b;
            }
            &::before {
                content: '';
                display: block;
                width: 100%;
                height: 100%;
                z-index: -1;
                position: absolute;
                top: 0px;
                left: -0.0299vw;
                border: 10px solid;
                box-sizing: border-box;
                border-image: url('./imgs/title_bg_capture.png') 10 stretch;
            }
        }
        .logo-left-no {
            &::before {
                border: 0;
            }
        }
    }
    .offbtn-box {
        // flex: 1;
        min-width: 41px;
        display: flex;
        .offbtn-box-right {
            flex: 1;
            position: relative;
            margin-top: 4px;
            &::after {
                content: '';
                display: block;
                width: calc(100% - 10px);
                height: calc(100% - 10px);
                z-index: -2;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: #142b7b;
            }
            &::before {
                content: '';
                display: block;
                width: 100%;
                height: 100%;
                z-index: -1;
                position: absolute;
                top: 0px;
                left: 0px;
                border: 10px solid;
                box-sizing: border-box;
                border-image: url('./imgs/title_bg_capture.png') 10 stretch;
            }
        }
    }
    // background-color: hsl(238, 91%, 13%);
    @include e(nav) {
        color: white;
        font-size: 18px;
        height: 42px;
        line-height: 41px;
        text-align: center;
        position: relative;
        margin-top: 5px;
        cursor: pointer;
        z-index: 0;
    }
    @include e(title) {
        width: 682px;
        height: 64px;
        text-align: center;
        line-height: 64px;
        color: white;
        font-size: 32px;
        position: relative;
        font-weight: 1000;
        text-shadow: 0 0 5px rgba(61, 255, 219, 1), 0 0 25px rgba(61, 255, 219, 1),
            0 0 50px rgba(61, 255, 219, 1), 0 0 200px #0586ff;
        @include e(title-light) {
            animation: titleLight 5s ease-in-out 0s infinite alternate;
            position: absolute;
            bottom: 0px;
            left: calc(50% - 100px);
            width: 200px;
            height: 20px;
            overflow: hidden;
            &::after {
                content: '';
                display: block;
                position: absolute;
                bottom: -2px;
                left: calc(50% - 10px);
                width: 15px;
                height: 7px;
                border-radius: 50%;
                // background-color: white;
                background-image: radial-gradient(150px 110px at 50% 50%, white, #0586ff);
                // color: #050801;
                box-shadow: 0 0 5px rgba(61, 255, 219, 1), 0 0 25px rgba(61, 255, 219, 1),
                    0 0 50px rgba(61, 255, 219, 1), 0 0 200px #0586ff;
            }
            &::before {
                content: '';
                display: block;
                position: absolute;
                bottom: 0px;
                left: 0px;
                width: 100%;
                height: 4px;
                // background-image: linear-gradient(90deg, red,rgba(61, 198, 219, 1), red);
                background-image: linear-gradient(
                    90deg,
                    rgba(61, 198, 219, 0),
                    rgba(5, 134, 255, 0.7),
                    rgba(61, 255, 219, 1),
                    white,
                    rgba(61, 255, 219, 1),
                    rgba(5, 134, 255, 0.7),
                    rgba(61, 198, 219, 0)
                );
            }
        }
        @include e(light1) {
            position: absolute;
            top: 22px;
            left: 91px;
        }
        @include e(light2) {
            position: absolute;
            top: 33px;
            left: 91px;
        }
        @include e(light3) {
            position: absolute;
            top: 22px;
            right: 91px;
        }
        @include e(light4) {
            position: absolute;
            top: 33px;
            right: 91px;
        }
    }
    .title-left {
        width: 166px;
        background: url(./imgs/title-left.png) no-repeat;
        &:hover {
            color: #000000;
            background: url(./imgs/title-left-off.png) no-repeat;
        }
    }
    .title-left-off {
        width: 166px;
        color: #000000;
        background: url(./imgs/title-left-off.png) no-repeat;
    }
    .title-left-in-off {
        width: 125px;
        background: url(./imgs/title-left-in-off.png) no-repeat;
    }
    .title-left-in {
        width: 125px;
        background: url(./imgs/title-left-in.png) no-repeat;
        &:hover {
            background: url(./imgs/title-left-in-off.png) no-repeat;
        }
    }
    .title-left-min-off {
        width: 73px;
        background: url(./imgs/title-left-min-off.png) no-repeat;
    }
    .title-left-min {
        width: 73px;
        background: url(./imgs/title-left-min.png) no-repeat;
        &:hover {
            background: url(./imgs/title-left-min-off.png) no-repeat;
        }
    }

    .title-right {
        width: 166px;
        background: url(./imgs/title-right.png) no-repeat;
        &:hover {
            color: #000000;
            background: url(./imgs/title-right-off.png) no-repeat;
        }
    }
    .title-right-off {
        width: 166px;
        color: #000000;
        background: url(./imgs/title-right-off.png) no-repeat;
    }
    .title-right-in {
        width: 125px;
        background: url(./imgs/title-right-in.png) no-repeat;
        &:hover {
            color: #000000;
            background: url(./imgs/title-right-in-off.png) no-repeat;
        }
    }
    .title-right-in-off {
        width: 125px;
        color: #000000;
        background: url(./imgs/title-right-in-off.png) no-repeat;
    }
    .title-right-min {
        width: 73px;
        background: url(./imgs/title-right-min.png) no-repeat;
        &:hover {
            color: #000000;
            background: url(./imgs/title-right-min-off.png) no-repeat;
        }
    }
    .title-right-min-off {
        width: 73px;
        color: #000000;
        background: url(./imgs/title-right-min-off.png) no-repeat;
    }

    .logo {
        margin-top: 6px;
        // margin-left: 1px;
        // position: absolute;
        // top: 14px;
        // left: 25px;
        //   cursor: pointer;
    }
    .offbtn {
        margin-top: 4px;
        line-height: 52px;
        height: 41px;
        text-align: center;
        width: 96px;
        display: flex;
        // justify-content: right;
        justify-content: flex-end;
        align-items: center;
        background: url(./imgs/Icon-out.png) no-repeat 100% 100%;
        cursor: pointer;
        .user-circular {
            width: 22px;
            height: 22px;
            text-align: center;
            background: #49f0fd;
            opacity: 1;
            line-height: 12px;
            border: 1px solid #ffffff;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 15px;
            .icon-user {
                height: 22px;
                width: 22px;
            }
        }
    }
}
</style>

<style lang="scss">
// 弹窗样式
.el-popper.el-popper[x-placement^='top'] .popper__arrow::after {
    bottom: 0px;
}
.el-tree-node:focus > .el-tree-node__content {
    background-color: #66b1ff87 !important;
}
.el-tree-node__content:hover {
    background-color: #66b1ff87;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #66b1ff87;
}
.el-popover {
    min-width: 50px;
}
.el-popper[x-placement^='bottom'] .popper__arrow::after {
    top: 0;
}
.el-popper.title-popover {
    text-align: center;
    color: white;
    padding: 0;
    border: none;
    background-clip: padding-box;
    // border-top: 15px solid transparent;
    // border-left: 15px solid transparent;
    // border-right: 15px solid transparent;
    // border-bottom: 28px solid transparent;
    // border-image: url(./imgs/mark-bg.png) 30 stretch;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    box-shadow: none;
    .popover-items {
        padding: 8px 2px 2px 2px;
        .el-tree-node__content > .el-tree-node__expand-icon {
            padding: 0;
        }
        .popover-item {
            height: 44px;
            line-height: 44px;
            text-align: center;
            cursor: pointer;
            border-bottom: 1px dashed rgba(73, 240, 253, 0.5);
            .popover-item-title {
                line-height: 24px;
                margin-left: 20px;
            }
            &:last-child {
                border-bottom: 0;
            }
        }

        .is-active {
            color: #000000;
            background: rgba(73, 240, 253, 0.75);
        }
    }
    .popover-trees {
        max-height: 500px;
    }
}
</style>
